import { Record } from 'immutable';
import { LOAD_SLIPS_SUCCESS } from '../../containers/bettingBuddy/actions';
import { LINK_ACCOUNTS_SUCCESS } from '../../containers/omniLink/actions';
import { CONSENTS_SAVE_REQUEST } from '../../containers/settings/MarketingPreferences/actions';
import { LOG_IN, LOG_OUT } from '../user/actions';
import {
  ACCOUNT_BALANCE_FAILURE,
  ACCOUNT_BALANCE_REQUEST,
  ACCOUNT_BALANCE_SUCCESS,
  ACCOUNT_DETAILS_FAILURE,
  ACCOUNT_DETAILS_REQUEST,
  ACCOUNT_DETAILS_SUCCESS,
  UPDATE_SAVED_SLIPS_COUNT
} from './actions';

const Consents = new Record({
  marketing: null
});

export const InitialState = new Record({
  detailsLoaded: false,
  detailsPending: false,
  phoneNumber: '',
  cardNumber: '',
  omniLinked: false,
  omniHasPIN: false,
  reConsent: false,
  consents: new Consents(),
  balancePending: false,
  totalBalance: '',
  availableBalance: null,
  numberOfSavedSlips: undefined
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case LOG_IN:
    case LOG_OUT: {
      return new InitialState();
    }
    case ACCOUNT_DETAILS_REQUEST: {
      return state
        .set('detailsPending', true)
        .set('phoneNumber', '')
        .set('cardNumber', '');
    }
    case ACCOUNT_DETAILS_SUCCESS: {
      return state
        .set('detailsLoaded', true)
        .set('detailsPending', false)
        .set('phoneNumber', action.results.phoneNumber)
        .set('cardNumber', action.results.printedCardNumber)
        .set('omniLinked', !!action.results.omniLinked)
        .set('omniHasPIN', !!action.results.omniHasPIN)
        .set('reConsent', action.results.consents === undefined)
        .set('consents', new Consents(action.results.consents))
        .set('numberOfSavedSlips', action.results.numberOfSavedSlips);
    }
    case ACCOUNT_DETAILS_FAILURE: {
      return state
        .set('detailsLoaded', false)
        .set('detailsPending', false)
        .set('phoneNumber', '')
        .set('cardNumber', '');
    }
    case ACCOUNT_BALANCE_REQUEST: {
      return state.set('balancePending', true);
    }
    case ACCOUNT_BALANCE_SUCCESS: {
      return state
        .set('totalBalance', action.results.totalBalanceFormatted)
        .set('availableBalance', action.results.availableBalanceValue)
        .set('balancePending', false);
    }
    case ACCOUNT_BALANCE_FAILURE: {
      return state
        .set('totalBalance', null)
        .set('availableBalance', null)
        .set('balancePending', false);
    }
    case LINK_ACCOUNTS_SUCCESS: {
      return state
        .set('omniLinked', true);
    }
    case CONSENTS_SAVE_REQUEST: {
      return state
        .set('reConsent', false)
        .set('consents', action.consents);
    }
    case UPDATE_SAVED_SLIPS_COUNT: {
      const currentSavedSlipsCount = state.get('numberOfSavedSlips');
      const calculatedSlipsCount = (
        !isNaN(currentSavedSlipsCount) && currentSavedSlipsCount + action.updateBy
      );
      return state.set('numberOfSavedSlips', calculatedSlipsCount);
    }
    case LOAD_SLIPS_SUCCESS: {
      return state.set('numberOfSavedSlips', action.slips.length);
    }
    default: {
      return state;
    }
  }
};
